<template>
<div class="chapter">
<div class="inner_page">
<a id="page_1"></a>
<p class="halftit">UNITED COUNTIES BUSES</p>
<p class="halftitle1">A FLEET HISTORY, 1921–2014</p>
<a id="page_2"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 001_Half_title.vue?6169818e